import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './Views/Shared/footer.js';
import Header from './Views/Shared/header.js';
import CookieConsent from './Views/Shared/CookieConsent.js';
import './assets/loader.css';

// Lazy loading ile sayfaları yükle
const HomePage = React.lazy(() => import('./Views/Home/HomePage.js'));
const About = React.lazy(() => import('./Views/Home/About.js'));
const Contact = React.lazy(() => import('./Views/Home/Contact.js'));
const InfoPage = React.lazy(() => import('./Views/Home/InfoPage.js'));
const Videos = React.lazy(() => import('./Views/Home/Videos.js'));
const Products = React.lazy(() => import('./Views/Home/Products.js'));
const Details = React.lazy(() => import('./Views/Home/Details.js'));

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hideLoader, setHideLoader] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      // Yükleme bittikten sonra loader'ı DOM'dan kaldır
      const timeout = setTimeout(() => setHideLoader(true), 500);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    <Router>
        {!hideLoader && (
          <div id="loader" className={`loader-overlay ${isLoading ? 'opacity-1' : 'opacity-0'}`}>
            <div className="loader"></div>
          </div>
        )}

        <div id="page" className={isLoading ? 'opacity-0' : 'opacity-1'}>
          <Header />

          <main>
            <Suspense fallback={
              <div className="loader-overlay opacity-1">
                <div className="loader"></div>
              </div>
            }>
              <Routes>
                <Route path="/" element={<HomePage setIsLoading={setIsLoading} />} />
                <Route path="/home" element={<HomePage setIsLoading={setIsLoading} />} />
                <Route path="/about" element={<About setIsLoading={setIsLoading} />} />
                <Route path="/contact" element={<Contact setIsLoading={setIsLoading} />} />
                <Route path="/info" element={<InfoPage setIsLoading={setIsLoading} />} />
                <Route path="/videos" element={<Videos setIsLoading={setIsLoading} />} />
                <Route path="/products" element={<Products setIsLoading={setIsLoading} />} />
                <Route path="/details" element={<Details setIsLoading={setIsLoading} />} />
              </Routes>
            </Suspense>
          </main>

          <a
            target="_blank"
            href="https://wa.me/905414850168"
            style={{
              display: 'inline-block',
              position: 'fixed',
              right: 0,
              bottom: '140px',
              borderRadius: '20px'
            }}
          >
            <img
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '15px 0 0 15px'
              }}
              src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
              alt="WhatsApp"
            />
          </a>

          <Footer />
          <CookieConsent />

          <div className="scroll-top not-visible">
            <i className="fa fa-angle-up"></i>
          </div>
        </div>
    </Router>
  );
};

export default App;
